import { useFormikContext, getIn } from 'formik';

export function useCRLFField(name: string, maxLength?: number) {
  const { values, setFieldValue } = useFormikContext<any>();
  const value: string = getIn(values, name) ?? '';

  const enforceCRLFAndLimit = (raw: string) => {
    let normalized = raw
      .replace(/\r\n/g, '\n')
      .replace(/\r/g, '\n')
      .replace(/\n/g, '\r\n');

    if (!maxLength) return normalized;

    let trimmed = '';
    let used = 0;

    for (let i = 0; i < normalized.length; ) {
      const isCRLF = normalized[i] === '\r' && normalized[i + 1] === '\n';
      const charSize = isCRLF ? 2 : 1;

      if (used + charSize > maxLength) break;

      if (isCRLF) {
        trimmed += '\r\n';
        used += 2;
        i += 2;
      } else {
        trimmed += normalized[i];
        used += 1;
        i += 1;
      }
    }

    return trimmed;
  };

  const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const fixed = enforceCRLFAndLimit(e.target.value);
    setFieldValue(name, fixed);
  };

  return {
    value,
    onChange
  };
}

